/* Maps a route to the tour flag that identifies its walkthrough. The header's
 * replay button uses it to say "replay the guide for this page", and
 * useTourTrigger uses it so every tour mounted on that page — including the
 * panel-level ones with their own flags — replays together. */
const ROUTES = [
  [/^\/projects\/edit\//, "singleProjectOnBoarding"],
  [/^\/projects(\/|$)/, "projectOnBoarding"],
  [/^\/projectTemplates\/(create|edit)(\/|$)/, "templateBuilderOnBoarding"],
  [/^\/projectTemplates(\/|$)/, "templateOnBoarding"],
  [/^\/reports(\/|$)/, "reportsOnBoarding"],
  [/^\/time-tracking(\/|$)/, "timeTrackingOnBoarding"],
  [/^\/tickets(\/|$)/, "ticketsOnBoarding"],
  [/^\/chat(\/|$)/, "chatOnBoarding"],
  [/^\/organization(\/|$)/, "organizationOnBoarding"],
  [/^\/customers(\/|$)/, "customerOnBoarding"],
  [/^\/users(\/|$)/, "userOnBoarding"],
  [/^\/teams(\/|$)/, "teamOnBoarding"],
  [/^\/roles(\/|$)/, "roleOnBoarding"],

  [/^\/tags(\/|$)/, "tagOnBoarding"],
  [/^\/letters(\/|$)/, "lettersOnBoarding"],
  [/^\/my-attendance(\/|$)/, "myAttendanceOnBoarding"],
  [/^\/attendance(\/|$)/, "attendanceOnBoarding"],
  [/^\/$/, "onboarding"],
];

export const tourFlagForPath = (pathname) => {
  const hit = ROUTES.find(([re]) => re.test(pathname));
  return hit ? hit[1] : null;
};

export default tourFlagForPath;
